import React, { createContext, useContext, useState } from 'react';
import api from '../services/api';
import * as auth from "../services/auth";
import { ILogin, ISession } from '../common/interfaces/signIn.interfaces';

interface AuthContextData {
  signed: boolean;
  user: ISession | null;
  showWelcomeModal: boolean;
  signIn(login: ILogin): Promise<void>;
  signOut(): void;
  closeWelcomeModal(): void;
  resetWelcomeModalPreference(): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const AuthProvider: React.FC = ({ children }) => {  

  const storagedUser = sessionStorage.getItem('@PortalEGCliente:user');
  const storagedToken = sessionStorage.getItem('@PortalEGCliente:token');
  let localUser: ISession | null = null;   
        
  if (storagedToken && storagedUser) {       
      localUser = (JSON.parse(storagedUser)) as ISession;       
      api.defaults.headers.Authorization = `Bearer ${storagedToken}`;      
  }
  
  const [user, setUser] = useState<ISession | null>((localUser));
  const [showWelcomeModal, setShowWelcomeModal] = useState<boolean>(false);
  
  const shouldShowModal = () => {
    const dontShow = localStorage.getItem('@PortalEGCliente:dontShowWelcomeModal');
    return dontShow !== 'true';
  };

  async function signIn(login : ILogin) {    
    const response = await auth.signIn(login);   
    let localUser = response;
    
    api.defaults.headers.Authorization = `Bearer ${response.token}`;

    sessionStorage.setItem('@PortalEGCliente:user', JSON.stringify(response));
    sessionStorage.setItem('@PortalEGCliente:token', response.token);

    setUser(localUser);

    if (shouldShowModal()) {
      setShowWelcomeModal(false);
    }
  }

  function signOut() {
    setUser(null);
    setShowWelcomeModal(false);
    sessionStorage.clear();    
  }

  function closeWelcomeModal() {
    setShowWelcomeModal(false);
  }


  function resetWelcomeModalPreference() {
    localStorage.removeItem('@PortalEGCliente:dontShowWelcomeModal');
    console.log('✅ Preferência do modal removida! O modal voltará a aparecer no próximo login.');
  }


  return (
    <AuthContext.Provider
      value={{ signed: !!user, user, showWelcomeModal, signIn, signOut, closeWelcomeModal, resetWelcomeModalPreference }}>
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("hook must be used with an Provider")
  }

  return context;
}

export { AuthProvider, useAuth };